import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TipoFacturacion } from 'src/app/domain/model/catalogo/tipo-facturacion';

/**
 * Adaptador HTTP: HttpTipoFacturacionRepository
 *
 * Servicio para comunicación HTTP con el catálogo de Tipos de Facturación.
 * Endpoint: GET /api/servicios/tipos-facturacion
 */
@Injectable({ providedIn: 'root' })
export class HttpTipoFacturacionRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/tipos-facturacion`;

  /** Lista todos los tipos de facturación activos. */
  async listarActivos(): Promise<TipoFacturacion[]> {
    return firstValueFrom(
      this.http.get<TipoFacturacion[]>(this.baseUrl)
    );
  }
}
